export default __webpack_public_path__ + "static/media/res-project-2.f76f838d.webp";